<template>
    <b-notification :closable="false" :duration="10000">
        {{ $t("redirect2shop") }}
        <b-loading is-full-page>
            <b-icon
                pack="fas"
                icon="sync-alt"
                size="is-large"
                custom-class="fa-spin">
            </b-icon>
        </b-loading>
    </b-notification>
</template>

<script>
import site_config from "@/config"

export default {
    name: "Redirect2Shop",
    mounted () {
        localStorage.removeItem ("useAs")
        window.location.href = site_config.base_url + "shop/logout/"
    }
}
</script>
